import React from "react";
import "./BillingCard.scss";

const BillingCard: React.FC = () => {
  return (
    <div className="BillingCard">
      <div className="BillingCard__cardIcon">
        <img src="/icons/visa.png" alt="cardIcon" />
      </div>
      <div className="BillingCard__contentBox">
        <p>Visa Ending in 1234</p>
        <p>Expiry 06/24</p>
        <div className="buttonBox">
          <p>Set As Default</p>
          <p>Edit</p>
        </div>
      </div>
      {/* <div className="BillingCard__contentBox"></div> */}
    </div>
  );
}

export default BillingCard;